import type { StateCreator } from 'zustand'
import type { DashboardStore, PersistMutator } from './index'

export interface WorkspaceSlice {
  /**
   * Internal id of the signed-in (or impersonated) user. Derived from auth, so
   * it is NOT persisted — it's re-set on every load once the profile resolves.
   */
  currentUserId: string | null
  /** Persisted per-user workspace selection, keyed by internal user id. */
  workspaceIdsByUserId: Record<string, string>
  setCurrentUserId: (userId: string | null) => void
  setWorkspaceId: (userId: string, id: string | null) => void
}

export const createWorkspaceSlice: StateCreator<DashboardStore, PersistMutator, [], WorkspaceSlice> = (
  set,
) => ({
  currentUserId: null,
  workspaceIdsByUserId: {},
  setCurrentUserId: (userId) => set({ currentUserId: userId }),
  setWorkspaceId: (userId, id) =>
    set((state) => {
      const workspaceIdsByUserId = { ...state.workspaceIdsByUserId }
      if (id) {
        workspaceIdsByUserId[userId] = id
      } else {
        delete workspaceIdsByUserId[userId]
      }
      return { workspaceIdsByUserId }
    }),
})
